import React from "react";
import { Select } from "antd";

class BrdgxNationalitySelector extends React.Component {
  render() {
    const nationalities = this.props.nationalities;
    return (
      <Select
        showSearch
        style={{ width: 200, ...this.props.style }}
        size={this.props.size}
        placeholder={this.props.placeholder}
        optionFilterProp="children"
        onChange={this.props.onChange}
        value={this.props.value || undefined}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        mode={this.props.mode || "default"}
      >
        {nationalities.map((nationality) => {
          return (
            <Select.Option value={nationality.nationalityCode} key={nationality.nationalityCode}>
              {nationality.nationality}
            </Select.Option>
          );
        })}
      </Select>
    );
  }
}

export default BrdgxNationalitySelector;
